<div *ngIf="offer" fxLayout="column">
    <mat-card *ngIf="flags['annonceDisplayed']" appCard
              style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ 'Annonces' | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <app-table-commun-portail (emitNotDisplayAnnonceEvent)="flags['annonceDisplayed'] = $event !== 0" (openDialogListAttachedFilesEvent)="openDialogListAttachedFiles($event)"
                                      [data]="[offer]"
                                      [page]="'listAnnoncesPortail'">
            </app-table-commun-portail>
        </mat-card-content>
    </mat-card>

    <div [ngStyle]="{'margin-top': flags['annonceDisplayed']?'4%':'0'}">
        <app-fiche-consultation [dataColumnsAr]="constantePortail.genInfosCardFicheDetailsAO['displayedColumns']['ar']"
                                [dataColumnsEn]="constantePortail.genInfosCardFicheDetailsAO['displayedColumns']['en']"
                                [dataColumns]="constantePortail.genInfosCardFicheDetailsAO['displayedColumns']['fr']"
                                [data]="[offer]"
                                [label]="constantePortail.genInfosCardFicheDetailsAO['title']"
                                [labels]="constantePortail.genInfosCardFicheDetailsAO['labels']"
                                [langue]="getlang()"
        >
        </app-fiche-consultation>
    </div>

    <div style="margin-top: 4%">
        <app-fiche-consultation [dataColumnsAr]="infoSurAOFicheDetailsAO['displayedColumns']['ar']"
                                [dataColumnsEn]="infoSurAOFicheDetailsAO['displayedColumns']['en']"
                                [dataColumns]="infoSurAOFicheDetailsAO['displayedColumns']['fr']"
                                [data]="[offer]"
                                [label]="infoSurAOFicheDetailsAO['title']"
                                [labels]="infoSurAOFicheDetailsAO['labels']"
                                [langue]="getlang()"
                                style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2);margin-top: 3%;"
        >
        </app-fiche-consultation>
    </div>

    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ "Informations par lot ou article" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
                <app-tabletree [list]="datatree"></app-tabletree>
            </div>
        </mat-card-content>
    </mat-card>


    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ "Conditions de participation" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">

                <app-participation-table [participations]="participations"></app-participation-table>
                <!-- <app-paginator
                (paginate)="onPaginate($event)"
                [total]="searchh.count"
              ></app-paginator> -->

            </div>
        </mat-card-content>
    </mat-card>

    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ "Informations par produit" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">

                <app-info-prod-table [infosprodlist]="infosprodlist"
                ></app-info-prod-table>
                <!-- <app-paginator
                (paginate)="onPaginate($event)"
                [total]="searchh.count"
              ></app-paginator> -->

            </div>
        </mat-card-content>
    </mat-card>
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ "Cahier des charges" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
                <app-details-cahier-offrep [id]="bidNo"></app-details-cahier-offrep>
            </div>

        </mat-card-content>

    </mat-card>

    <div class="mt-3" fxFlex="100" fxFlex.md="100" fxLayout="row" fxLayoutAlign="end center">
        <button (click)="openFicheListSoumissionaires()" [disabled]="!flags['soumissionaireRetenu']" color="primary"
                mat-raised-button>
            {{ "Soumissionnaire(s) retenu(s)" | translate}}
        </button>
        <button (click)="openFicheResultatOuverture()" [disabled]="!flags['resultatOuvPublished']" class="mx-2" color="primary"
                mat-raised-button>
            {{ "Résultat" | translate}}
        </button>
        <button [routerLink]="['/portail/offres']" mat-raised-button style="background-color:#3E90D0; color: white;">
            {{"Précédent"|translate}}
        </button>
    </div>
</div>

<app-spinner-container [isLoading]="!offer"></app-spinner-container>
